import React from "react";
import { Typography, Box, List, ListItem, ListItemText, Divider, Grid, Button, Chip } from "@mui/material";

const Education = ({ prevStep, nextStep }) => {
  const rules = [
    "Ensure you are ready for education as per your timetable",
    "You are required to complete 25hrs of education a week",
    "Staff are here to support you achieve your education learning",
    "Some education will be online, some face to face, some completed through activities and some will be educational trips",
    "If you do not understand the work set staff are here to help you",
  ];

  return (
    <Box className='house-rules-container'>
      <Box className='header-section-house'>
        <Chip label='Admission' />
        <Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
          House Rules
        </Typography>
        <br />
        <Divider className='divider' />
      </Box>
      <Box className='content-section'>
        <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }} align='left'>
          Education
        </Typography>
        <Typography sx={{ fontSize: "14px" }}>
          "Engage in weekly planned activities and ensure that all equipment is stored and used safely."
        </Typography>
        <List className='rules-list'>
          {rules.map((rule, index) => (
            <ListItem key={index} className='rule-item'>
              <ListItemText primary={<Typography sx={{ fontSize: "14px", color: "black" }}>{rule}</Typography>} />
            </ListItem>
          ))}
        </List>
      </Box>
      <Grid container justifyContent='space-between' alignItems='center' mt={2} ml={1} mr={2}>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={prevStep}>
            Previous
          </Button>
        </Grid>
        <Grid item>
          <Button type='button' variant='contained' color='primary' onClick={nextStep}>
            Next
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Education;
